<template>
    <div class="other-tenant-item-content other-tenant-time-delay">
        <div class="other-tenant-time-delay-left">
            <span class="other-tenant-title">页面操作延时TOP</span>
            <div id="timeDelay"></div>
        </div>
        <div class="other-tenant-time-delay-right">
            <span class="other-tenant-title">页面操作频次TOP5</span>
            <div class="time-delay-list">
                <ul>
                    <li class="time-delay-list-item" v-for="(item,index) in timeFrequency.slice(0,5)" :key="index">
                        <div class="time-delay-list-left">
                           <span class="time-delay-list-rank">{{index+1}}</span>
                            <span class="time-delay-list-tittle" :title="item.opDesc">{{item.opDesc}}</span>
                        </div>
                        <div class="time-delay-list-num">{{item.count}}</div>
                    </li>
                </ul>
                <span v-show="isTimeFrequency" class="time-delay-more" @click="openDeatil()">查看更多
                    <img src="../../../../../assets/images/arrow.svg" width="20" height="10" alt="">
                </span>
            </div>
        </div>
        <!-- 操作延时Top弹窗 -->
        <el-dialog width="532px" :title="'页面操作延时TOP_' + dialogTitle" :visible.sync="dialogVisible" :close-on-click-modal="false">
            <div class="time-delay-change-link">
                <el-button type="text" @click="changeDetailStyle">切换</el-button>
            </div>
            <div v-show="!isDetailBar" id="timeDetailDelay"></div>
            <el-table v-show="isDetailBar" :data="tableData" height="300" @row-click="jumpLog">
                <el-table-column prop="apiName" label="接口名称"></el-table-column>
                <el-table-column prop="count" label="数量" width="100" :formatter="formatterData"></el-table-column>
            </el-table>
        </el-dialog>
        <!-- 页面操作频次TOP5 -->
        <el-dialog
            width="500px"
            title="页面操作频次TOP"
            :visible.sync="rankDialogVisible"
            :close-on-click-modal="false">
            <el-table :data="timeFrequency" height="300">
                <el-table-column prop="opDesc" label="页面名称"></el-table-column>
                <el-table-column prop="count" label="频次" width="100" :formatter="formatterData"></el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
                <el-button @click="rankDialogVisible = false">取 消</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import { getTimeDelayOption } from './timeDelayOptions';
import { getTimeDelayTopDetailApi } from '../../../../../api/afterLoginIndex';
const DETAIL_TIME = { // 明细弹窗对照
    '60s及以上': [60000, 600000],
    '30-60s': [30000, 59999],
    '9-10s': [9000, 9999],
    '7-8s': [7000, 8999],
    '5-6s': [5000, 6999],
    '3-4s': [3000, 4999],
    '1-2s': [1000, 2999]
};
export default {
    data() {
        return {
            dialogVisible: false,
            rankDialogVisible: false,
            dialogTitle: '',
            tableData: [],
            isDetailBar: false,
            timeFrequency: [],
            timeDelayObj: {},
            time: ''
        };
    },
    computed: {
        isTimeFrequency() {
            return this.timeFrequency.length > 5;
        }
    },
    methods: {
        drawEcharts() {
            let myChart = this.$echarts.init(document.getElementById('timeDelay'));
            if (myChart) { myChart.dispose(); }
            myChart = this.$echarts.init(document.getElementById('timeDelay'));
            // 绘制图表
            this.$nextTick(() => {
                myChart.setOption(getTimeDelayOption(this.timeDelayObj));
                myChart.off('click'); // 防止触发两次点击事件
                myChart.on('click', (params) => {
                    params.name && this.getDetailMain(params.name);
                });
            });
        },
        drawDetailEcharts() {
            let myChart = this.$echarts.init(document.getElementById('timeDetailDelay'));
            if (myChart) { myChart.dispose(); }
            myChart = this.$echarts.init(document.getElementById('timeDetailDelay'));
            // 绘制图表
            this.$nextTick(() => {
                myChart.setOption(getTimeDelayOption(this.tableData, 'detail'));
                myChart.off('click'); // 防止触发两次点击事件
                myChart.on('click', (params) => {
                    this.jumpLog();
                });
            });
        },
        formatSearchParam(dataName) {
            const params = {
                startTime: this.time + ' 00:00:00',
                endTime: this.time + ' 23:59:59',
                timeRequest: DETAIL_TIME[dataName][0],
                ltTimeRequest: DETAIL_TIME[dataName][1]
            };
            return params;
        },
        getDetailMain(dataName) {
            this.dialogTitle = dataName;
            this.isDetailBar = false;
            this.dialogVisible = true;
            this.tableData = [];
            const params = this.formatSearchParam(dataName);
            getTimeDelayTopDetailApi(params).then(res => {
                if (res && +res.code === 0) {
                    const data = res.data || {};
                    this.tableData = data.apiPieDtos || [];
                    this.$nextTick(() => {
                        this.drawDetailEcharts();
                    });
                }
            });
        },
        changeDetailStyle() {
            this.isDetailBar = !this.isDetailBar;
        },
        openDeatil() {
            this.rankDialogVisible = true;
        },
        formatterData(row, column, cellValue) {
            return cellValue ? cellValue.toLocaleString() : cellValue;
        },
        dataProcess(data) {
            this.timeFrequency = data.map(item => {
                return {
                    opDesc: item.opDesc,
                    count: (item.count).toLocaleString()
                };
            });
        },
        dataEchartsProcess(data) {
            this.timeDelayObj = data.data || {};
            this.time = data.time;
            this.$nextTick(() => {
                this.drawEcharts();
            });
        },
        jumpLog() {
            this.$router.push('/operationLog');
        }
    }
};
</script>
<style lang="less">
.other-tenant-time-delay{
    display: flex;
    justify-content: space-between;
    .other-tenant-time-delay-left{
        width: 52%;
        height: 296px;
    }
    .other-tenant-time-delay-right{
        width: calc(48% - 64px);
    }
    #timeDelay{
        height: calc(100% - 34px);
        width: 100%;
    }
    #timeDetailDelay{
        width: 100%;
        height: 300px;
    }
    .time-delay-change-link{
        display: flex;
        justify-content: end;
    }
    .time-delay-list-item{
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-family: 'PingFangSC-Regular', sans-serif;
        font-size: 12px;
        line-height: 40px;
        color: #333333;
        font-weight: 400;
    }
    .time-delay-list-rank{
        display: inline-block;
        width: 16px;
        height: 16px;
        line-height: 16px;
        margin-right: 8px;
        vertical-align: middle;
        text-align: center;
        background: rgba(66,133,245,0.10);
        border-radius: 2px;
        color: #4285f5;

    }
    .time-delay-list-tittle{
        vertical-align: middle;
        display: inline-block;
        width: calc(100% - 25px);
        overflow:hidden;
        white-space:nowrap;
        text-overflow:ellipsis;
    }
    .time-delay-list-left{
        width: calc(100% - 70px);
    }
    .time-delay-list-num{
        color:  #4285f5;
        font-weight: 600;
        font-size: 14px;
        font-family: 'PingFangSC-Medium', sans-serif;
    }
    .time-delay-more{
        margin-top: 8px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        box-sizing: border-box;
        padding: 0 10px;
        width: 111px;
        height: 24px;
        font-family: 'PingFangSC-Regular', sans-serif;
        font-size: 12px;
        color: #999999;
        font-weight: 400;
        box-shadow: 0px 2px 4px 1px rgba(43,131,253,0.1);
        border-radius: 2px;
        cursor: pointer;
    }
}
</style>